<template>
	<v-card
		rounded="lg"
		flat
		v-bind="$attrs"
		data-aos="flip-left"
		width="100%"
	>
		<div style="height: 70px">
			<div
				class="text-right pa-5 red--text text--lighten-2 font-weight-bold text-wrap"
				:class="MIXIN_SETUP_UI.title"
			>
				<span v-show="discount" class="peso"><span v-html="MIXIN_PESO_SIGN"></span>{{ discount | numFormat('0.00') }} OFF</span>
			</div>
		</div>
		<div style="min-height: 100px">
			<div
				:class="[ MIXIN_SETUP_UI.show ? 'px-5' : 'px-3', MIXIN_SETUP_UI.title]"
				class="text-center font-weight-light pb-5 pt-2 text-wrap"
			>
				{{ name }}
			</div>
		</div>
		<h1 class="text-center">
			<span class="peso primary--text" v-html="MIXIN_PESO_SIGN"></span>
			<span class="primary--text">{{ price | numFormat }}</span>
			<span class="label">{{ price | numFormat('.00') }} / YR</span>
		</h1>
		<p class="text-center black--text font-weight-bold">*VAT ex</p>
		<v-row justify="center" class="ma-5">
			<base-button
				x-large
				name="Add to cart"
				color="#0e6ccd"
				@click="addToCart()"
				:disabled="disable"
			></base-button>
		</v-row>

		<div class="blue lighten-4">
			<p class="text-center pa-3">Unlimited teleconsultation</p>
		</div>

		<h4 class="text-center pb-5 px-5 font-weight-light pre-wrap">{{ description }}</h4>
	</v-card>
</template>

<script>
	export default {
		name: "PlanCard",
		props: {
			name: { type: String, default: '' },
			price: { type: Number, default: 0 },
			discount: { type: Number },
			description: { type: String, default: '' },
			disable: { type: Boolean, default: false }
		},
		methods: {
			addToCart() {
				this.$emit('add');
			}
		}
	}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss";

.peso {
	font-family: Arial;
}

.label {
	font-size: 14px;
}

h1 {
	letter-spacing: 0.5px;
}
</style>